import config from '../config'
import http from '../http'

export default{
    //仓库，卖家获取任务列表
    getTask:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_TASKGET,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

    //卖家创建任务
    createTask:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_CREATE,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},
    //卖家删除任务
    deleteTask:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_DELETE,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

    //根据国家获取任务类型
    getTaskType:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_TYPE_GET,
			method: 'get',
			data: {
			...payload,
			},
		})
		return res.data
	},
    //卖家退回仓库确认
    sellerReturn:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_CANCELCONFIRM,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

    //卖家确认任务完成
    sellerConfirmEnd:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_SELLERCONFIRM,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

    //卖家确认仓库提出的额外费用
    sellerConfirmExtra:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_EXTRACONFIRM,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

    //仓库接单
    storeReceipt:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_RECEIPT,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

    //仓库添加额外费用 
    storeAddExtraFee:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_STREO_EXTRA,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

    //仓库添加额外费用 
    storeConfirm:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_STORE_COMFIRM,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},

	//发送留言信息 
    sendMessage:async function(payload) {
		const res = await http({
			url: config.STORE_AFFAIRS_SEND,
			method: 'post',
			data: {
			...payload,
			},
		})
		return res.data
	},



}